import { ElementRef } from '@angular/core';
import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/core/ajax.service";
import * as i2 from "Angular/services/core/urls.service";
import * as i3 from "@angular/common";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
function CancelAccountModalComponent_p_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.errorMessage);
} }
export class CancelAccountModalComponent {
    constructor(ajaxService, eltRef, urlService) {
        this.ajaxService = ajaxService;
        this.eltRef = eltRef;
        this.urlService = urlService;
        this.isOpen = false;
        this.contactRedirect = this.urlService.SUPPORT.CONTACT_REDIRECT;
        this.paidThroughDate = this.eltRef.nativeElement.getAttribute('paidThroughDate');
        if (this.paidThroughDate == null) {
            this.paidThroughDate = new Date();
        }
    }
    closeModal() {
        this.isOpen = false;
        this.errorMessage = null;
    }
    openModal() {
        this.isOpen = true;
    }
    cancelAccount() {
        this.ajaxService.putDataObserveResponse(this.urlService.ENTITLEMENTS.CANCEL_SUBSCRIPTION, {}).subscribe((response) => {
            if (response.status !== 200) {
                this.errorMessage = response;
            }
            else {
                this.closeModal();
                window.location.href = this.urlService.ACCOUNTS.ACCOUNT_PROFILE;
            }
        }, (response) => {
            this.errorMessage = response.error.error;
        });
    }
}
CancelAccountModalComponent.ɵfac = function CancelAccountModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CancelAccountModalComponent)(i0.ɵɵdirectiveInject(i1.AjaxService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i2.UrlsService)); };
CancelAccountModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CancelAccountModalComponent, selectors: [["ycn-cancel-account-modal"]], standalone: false, decls: 26, vars: 7, consts: [[1, "btn", "btn-outline", "btn-danger", 3, "click"], [3, "closeModalHandler", "open"], ["header", "We're sorry to see you go!", 3, "closeModalHandler"], [1, "modal-body"], [1, "modal-section"], [1, "text-bold"], [1, "text-blue", 3, "href"], ["class", "text-red", 4, "ngIf"], [1, "modal-footer"], [1, "modal-footer-actions"], [1, "btn", "btn-text", 3, "click"], [1, "text-red"]], template: function CancelAccountModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵlistener("click", function CancelAccountModalComponent_Template_div_click_0_listener() { return ctx.openModal(); });
        i0.ɵɵtext(1, "Cancel Account");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "ycn-modal-base", 1);
        i0.ɵɵlistener("closeModalHandler", function CancelAccountModalComponent_Template_ycn_modal_base_closeModalHandler_2_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(3, "ycn-simple-modal-header", 2);
        i0.ɵɵlistener("closeModalHandler", function CancelAccountModalComponent_Template_ycn_simple_modal_header_closeModalHandler_3_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3)(5, "div", 4)(6, "p");
        i0.ɵɵtext(7, "By canceling your membership, on ");
        i0.ɵɵelementStart(8, "span", 5);
        i0.ɵɵtext(9);
        i0.ɵɵelementEnd();
        i0.ɵɵtext(10, ", you will lose access to your account and all saved data and reports. ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "p");
        i0.ɵɵtext(12, "If you have an idea or error you would like to report so that YCharts would be a better product for you, feel free to:");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "p")(14, "a", 6);
        i0.ɵɵtext(15, "Submit a feature request");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(16, "br");
        i0.ɵɵelementStart(17, "a", 6);
        i0.ɵɵtext(18, "Submit an error report");
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(19, CancelAccountModalComponent_p_19_Template, 2, 1, "p", 7);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(20, "div", 8)(21, "div", 9)(22, "div", 10);
        i0.ɵɵlistener("click", function CancelAccountModalComponent_Template_div_click_22_listener() { return ctx.closeModal(); });
        i0.ɵɵtext(23, "Back");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(24, "div", 0);
        i0.ɵɵlistener("click", function CancelAccountModalComponent_Template_div_click_24_listener() { return ctx.cancelAccount(); });
        i0.ɵɵtext(25, "Cancel Account");
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("open", ctx.isOpen);
        i0.ɵɵadvance(7);
        i0.ɵɵtextInterpolate(ctx.paidThroughDate);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("href", i0.ɵɵinterpolate(ctx.contactRedirect), i0.ɵɵsanitizeUrl);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("href", i0.ɵɵinterpolate(ctx.contactRedirect), i0.ɵɵsanitizeUrl);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.errorMessage);
    } }, dependencies: [i3.NgIf, i4.ModalBaseComponent, i5.SimpleModalHeaderComponent], encapsulation: 2 });
